import React from "react";

import Schedule from "./Schedule";

import axios from "axios";

import { parseSchedule } from "../../Helpers/parse";

const ScheduleEmbed = ({
  id,
  webScheduleLive,
  webSchedulePrimary,
  webScheduleSecondary,
  webScheduleAvailable,
  color,
}) => {
  let [state, setState] = React.useState({
    schedule: [],
    schedule_info: {},
    schedule_metadata: {},
  });

  React.useEffect(() => {
    const loadSchedule = async () => {
      axios
        .post(
          "https://imd0mxanj2.execute-api.us-west-2.amazonaws.com/upload/getLive", {
          live: id
        })
        .then((res) => {
          let url = res.data.response.payload.live
          let totalUrl = url.split('/');
          let channel = totalUrl[totalUrl.length - 2]
          let client = totalUrl[4]
          let apiLink = `https://api.castus.tv/ccs/v1/schedule/${client}/${channel}`
          axios
            .get(apiLink)
            .then(({ data }) => {
              if(data.items) {
                data = parseSchedule(data);
              }
              setState({
                schedule: data.schedule,
                schedule_info: data.report,
                schedule_metadata: data.metadata,
              });
            });
        });
    };
    loadSchedule();
  }, [id]);

  return (
    <div style={{ padding: ".5rem" }}>
      <Schedule
        id={id}
        visible={true}
        schedule={state.schedule}
        schedule_info={state.schedule_info}
        schedule_metadata={state.schedule_metadata}
        color={color}
        setFile={(file) => {
          window.open(
            window.location.href.split("embed")[0] + "video/" + file._id,
            "_blank"
          );
        }}
        webScheduleLive={webScheduleLive}
        webSchedulePrimary={webSchedulePrimary}
        webScheduleSecondary={webScheduleSecondary}
        webScheduleAvailable={webScheduleAvailable}
      />
    </div>
  );
};

export default ScheduleEmbed;
